export interface LandingWidgetInitConfig {
  apiBaseUrl: string;
  launcherPosition: 'bottom-right';
  showLauncher: true;
  defaultOpen: false;
  themeColor?: string;
  title?: string;
}

export interface LandingWidgetRuntimeConfig {
  scriptUrl: string;
  initConfig: LandingWidgetInitConfig;
}

export function buildLandingWidgetConfig(
  env: Partial<ImportMetaEnv>,
): LandingWidgetRuntimeConfig | null {
  const scriptUrl = env.VITE_WIDGET_SCRIPT_URL?.trim();
  const apiBaseUrl = env.VITE_API_BASE_URL?.trim();

  if (!scriptUrl || !apiBaseUrl) {
    return null;
  }

  return {
    scriptUrl,
    initConfig: {
      apiBaseUrl,
      launcherPosition: 'bottom-right',
      showLauncher: true,
      defaultOpen: false,
      ...(env.VITE_WIDGET_THEME_COLOR ? { themeColor: env.VITE_WIDGET_THEME_COLOR } : {}),
      ...(env.VITE_WIDGET_TITLE ? { title: env.VITE_WIDGET_TITLE } : {}),
    },
  };
}
